export const fonts = {
  brand: {
    fonts: {
      default: 'AdihausDINCn, sans-serif'
    }
  }
}
